<template>
    <custom-drawer
        v-loading.fullscreen.lock="m__loading"
        size="60%"
        :wrapper_closable="false"
        :visible.sync="visible_in_line"
    >
        <template slot="title">
            <div class="items-center justify-between flex-1 h-full flex px-12">
                <div>
                    <p class="font-semibold text-[0.9rem]">
                        {{ this.$t('page.campaign.adgroup_pane.edit_adgroup') }}
                    </p>
                    <p v-if="objective_type" class="component-text-desc">
                        {{ $t('common.objective_type') }} :
                        {{ p__formatObjectiveType(objective_type) }}
                    </p>
                </div>
                <!-- <el-button
                    type="primary"
                    size="small"
                    @click="handleNextStep"
                >
                    {{ $t('button.next') }}
                    <i class="el-icon-right"></i>
                </el-button> -->
                <el-button
                    :disabled="list_errors.length > 0"
                    type="primary"
                    size="small"
                    @click="handleCopy"
                >
                    {{ $t('common.copy') }}
                    <i class="el-icon-copy-document"></i>
                </el-button>
            </div>
        </template>

        <div
            v-if="list_campaigns.length && selected_campaign"
            class="fixed top-[64px] left-[40%] translate-x-[-104%]"
        >
            <div class="component-box w-[280px]">
                <p class="font-semibold text-[0.9rem]">
                    {{ this.$t('page.campaign.target_campaigns') }}
                </p>

                <ul class="mt-2">
                    <li
                        v-for="item in list_campaigns"
                        :key="item.campaign_id"
                        class="text-[0.85rem] mt-1 cursor-pointer rounded-lg py-2 px-3"
                        :class="[
                            selected_campaign.campaign_id === item.campaign_id
                                ? 'bg-bg'
                                : 'hover:bg-bg'
                        ]"
                        @click="handleSelectCampaign(item)"
                    >
                        <el-tooltip
                            effect="dark"
                            :content="item.campaign_name"
                            placement="left"
                        >
                            <p class="truncate w-[200px]">
                                {{ item.campaign_name }}
                            </p>
                        </el-tooltip>
                    </li>
                </ul>
            </div>
        </div>

        <div class="flex h-full">
            <div class="w-[68px] bg-white border-r-[1px] border-border">
                <div
                    v-if="
                        selected_campaign && selected_campaign.adgroups.length
                    "
                    class="flex flex-col"
                >
                    <ul class="pt-4">
                        <li
                            v-for="(item, index) in selected_campaign.adgroups"
                            :key="index"
                            class="pb-3 util-flex-center"
                            @click="selected_adgroup = item"
                        >
                            <div
                                class="w-10 h-10 util-flex-center rounded-lg"
                                :class="[
                                    selected_adgroup &&
                                    selected_adgroup.id === item.id
                                        ? 'text-white bg-brand-atosa--light'
                                        : 'bg-bg cursor-pointer'
                                ]"
                            >
                                <p class="text-[0.85rem]">
                                    {{ index + 1 }}
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div
                v-if="selected_adgroup"
                class="flex-1 h-full pt-4 flex space-x-4 px-12 overflow-auto"
            >
                <div>
                    <el-alert
                        v-if="list_errors.length > 0"
                        :title="$t('common.warning')"
                        type="warning"
                        :closable="false"
                        class="mb-4"
                    >
                        <p v-for="(item, index) in list_errors" :key="index">
                            {{ item }}
                        </p>
                    </el-alert>

                    <EditAdGroupForm
                        :selected_item.sync="selected_adgroup"
                        :currency="currency"
                        :timezone="timezone"
                        :tiktok_account_id="tiktok_account_id"
                        :belong_to_atosa="belong_to_atosa"
                        :advertiser_id="advertiser_id"
                        :objective_type="objective_type"
                        type_form="copy"
                    ></EditAdGroupForm>
                </div>

                <CustomTargetAdgroupBox
                    v-if="
                        selected_adgroup &&
                        ['PRODUCT_SALES'].some(
                            (item) => item !== objective_type
                        )
                    "
                    class="min-w-[320px] w-[320px]"
                    :tiktok_account_id="tiktok_account_id"
                    :objective_type="objective_type"
                    :selected_item.sync="selected_adgroup"
                ></CustomTargetAdgroupBox>
            </div>
        </div>

        <CreateSuccessDialog
            :visible.sync="show_create_success_dialog"
            :advertiser_id="advertiser_id"
            :current_balance="current_balance"
            :currency="currency"
            @skip="visible_in_line = false"
        ></CreateSuccessDialog>
    </custom-drawer>
</template>

<script>
import { getAds, createAd } from '@/services/atosa-tiktok-ads/ad'
import {
    createAdGroup,
    updateAdgroupStatus
} from '@/services/atosa-tiktok-ads/adgroup'
import selectedTiktokAccountMixin from '@/plugins/mixins/selected-tiktok-accounts'
import { removeEmptyParams } from '@/views/campaign/_utils'
import EditAdgroupFormMixin from '@/components/orgranisms/edit-adgroup-form/_mixin'
import CreateSuccessDialog from './create-success-dialog'

export default {
    components: {
        CreateSuccessDialog
    },

    mixins: [selectedTiktokAccountMixin, EditAdgroupFormMixin],

    props: [
        'visible',
        'advertiser_id',
        'currency',
        'timezone',
        'min_budget_adgroup',
        'objective_type',
        'list_campaigns',
        'current_balance',
        'belong_to_atosa'
    ],

    data() {
        return {
            show_create_success_dialog: false,
            step: 1,
            selected_campaign: null,
            selected_adgroup: null,
            selected_ad: null,
            list_ads: [],
            list_errors: [],
            audience_size: null
        }
    },

    computed: {
        visible_in_line: {
            get() {
                return this.visible
            },
            set(value) {
                this.$emit('update:visible', value)
            }
        },

        tiktok_account_id() {
            return this.m__selected_tiktok_account
                ? this.m__selected_tiktok_account.id
                : null
        }
    },

    watch: {
        visible() {
            if (this.visible && this.list_campaigns.length) {
                this.list_errors = []

                this.handleSelectCampaign(this.list_campaigns[0])

                this.fetchAds()
            }
        }
    },

    mounted() {
        this.p__event_bus.$on(
            'eb_error_adgroup_no_find_identity',
            this.pushError
        )
        this.p__event_bus.$on('eb_error_adgroup_no_find_shop', this.pushError)
    },

    destroyed() {
        this.p__event_bus.$off(
            'eb_error_adgroup_no_find_identity',
            this.pushError
        )
        this.p__event_bus.$off('eb_error_adgroup_no_find_shop', this.pushError)
    },

    methods: {
        pushError(err) {
            this.list_errors.push(err)
        },

        handleSelectCampaign(item) {
            this.selected_campaign = item
            this.selected_adgroup = item.adgroups[0]
        },

        async fetchAds() {
            this.m__loading = true

            try {
                const response_get_ads = await getAds(
                    this.m__selected_tiktok_account.id,
                    {
                        advertiser_id: this.advertiser_id,
                        filtering: JSON.stringify({
                            adgroup_ids: [this.selected_adgroup.adgroup_id]
                        })
                    }
                )

                const list_ads = response_get_ads.data.list.map((item) => {
                    if (!item.ad_text) {
                        item.ad_text = 'ad'
                    }
                    delete item.brand_safety_postbid_partner
                    removeEmptyParams(item)
                    return item
                })

                if (list_ads.length) {
                    this.list_ads = list_ads
                } else {
                    this.pushError(
                        this.$t(
                            'page.campaign.message_adgroup_doesnt_have_any_ads'
                        )
                    )
                }
            } catch (error) {
                console.error(error)
            }
            this.m__loading = false
        },

        async handleCopy() {
            if (!this.list_ads.length) {
                return
            }

            try {
                let pass = false
                for (const item_campaign of this.list_campaigns) {
                    for (const item_adgroup of item_campaign.adgroups) {
                        pass = this.m__validAdgroup(item_adgroup)
                        if (!pass) {
                            this.selected_campaign = item_campaign
                            this.selected_adgroup = item_adgroup
                            return
                        }
                    }
                    if (!pass) {
                        return
                    }
                }
                if (!pass) {
                    return
                }

                this.m__loading = true
                let has_success = false

                await Promise.all(
                    this.list_campaigns.map(async (campaign) => {
                        let index = 0
                        let has_error = false
                        let created_adgroup_id = ''

                        for (const adgroup of campaign.adgroups) {
                            const temp_adgroup = JSON.parse(
                                JSON.stringify(adgroup)
                            )
                            index++
                            try {
                                removeEmptyParams(temp_adgroup)

                                this.m__changeScheduleTime2(temp_adgroup)

                                const response_create_adgroup =
                                    await createAdGroup(
                                        this.m__selected_tiktok_account.id,
                                        {
                                            ...temp_adgroup,
                                            campaign_id: campaign.campaign_id,
                                            belong_to_atosa:
                                                this.belong_to_atosa
                                        }
                                    )

                                if (response_create_adgroup.data?.adgroup_id) {
                                    created_adgroup_id =
                                        response_create_adgroup.data?.adgroup_id

                                    const response_create_ad = await createAd(
                                        this.m__selected_tiktok_account.id,
                                        {
                                            belong_to_atosa:
                                                this.belong_to_atosa,
                                            adgroup_id:
                                                response_create_adgroup.data
                                                    .adgroup_id,
                                            advertiser_id: this.advertiser_id,
                                            creatives: this.list_ads
                                        }
                                    )
                                    if (response_create_ad.code === 0) {
                                        has_success = true
                                    }
                                }
                            } catch (error) {
                                has_error = true
                                console.error(error)
                                this.p__showNotify(
                                    'error',
                                    `Ad Group ${index} : ${error.data.message}`
                                )
                            }

                            if (has_error && created_adgroup_id) {
                                try {
                                    await updateAdgroupStatus(
                                        this.tiktok_account_id,
                                        {
                                            advertiser_id: this.advertiser_id,
                                            adgroup_ids: [created_adgroup_id],
                                            operation_status: 'DELETE',
                                            belong_to_atosa:
                                                this.belong_to_atosa
                                        }
                                    )
                                } catch (error) {
                                    console.error(error)
                                }
                            }
                        }
                    })
                )
                if (has_success) {
                    this.p__showNotify(
                        'success',
                        this.$t('message.xxx_success', {
                            xxx: `${this.$t(`common.copy`)} ${this.$t(
                                `common.adgroup`
                            )}`
                        })
                    )
                    this.p__event_bus.$emit('eb_reload_campaign')
                    this.p__event_bus.$emit('eb_reload_adgroup')
                    this.p__event_bus.$emit('eb_reload_ad')

                    if (this.current_balance <= 300_000) {
                        this.show_create_success_dialog = true
                    } else {
                        this.visible_in_line = false
                    }
                }
            } catch (error) {
                console.error(error)
                this.p__showNotify(
                    'error',
                    this.$t('message.xxx_fail', {
                        xxx: `${this.$t(`common.copy`)} ${this.$t(
                            `common.adgroup`
                        )}`
                    })
                )
            }
            this.m__loading = false
        }
    }
}
</script>
